import '../../sass/about/about_history.sass'
import '../fesd/fesd'
import Blazy from 'blazy'

const _about_history = {
  // 時間軸事件
  getDotTop() {
    const dot = $('.time-line-box .dot');
    const firstYear = $('.time-zone').eq(0).find('.year');
    const firstLine = firstYear.offset().top;
    dot.each((index, el) => {
      let h = $(el).offset().top - firstLine;
      $(el).attr('data-top', h);
    });
  },
  lineEvent(scrollTop) {
    const line = $('.time-line-box .real-line');
    const dot = $('.time-line-box .dot');
    const timeLineTop = $('.time-line-box').offset().top - window.innerHeight / 3;
    let realTop, h, lineH;

    realTop = scrollTop - timeLineTop;
    h = (realTop / $('.time-line-box').height()) * 100;
    line.css('height', h + '%');
    lineH = line.height();
    // dot class
    dot.each((index, el) => {
      let dotTop = Number($(el).attr('data-top'));
      if(lineH >= dotTop) $(el).addClass('active');
      else $(el).removeClass('active');
    });
  },
  bindScroll() {
    const vm = this;
    $(window).off('scroll.time load.time').on('scroll.time load.time', function() {
      vm.lineEvent($(this).scrollTop());
    })
  },
  bindResize() {
    const vm = this;
    $(window).off('resize.aa').on('resize.aa', function() {
      vm.getDotTop();
      vm.lineEvent($(this).scrollTop());
    })
  },
  bindSlide() {
    const vm = this;
    const target = $('.time-line-box .year');
    target.off('click.aa').on('click.aa', function() {
      $(this).parents('.time-zone').find('.details').slideToggle(400);
      $(this).toggleClass('reverse');
      setTimeout(() => {
        vm.getDotTop();
        vm.lineEvent($(window).scrollTop());
        window._common.bLazy = new Blazy({
          offset: 100,
        });
      }, 400);
    });
  },
  timeLine() {
    // get height
    _about_history.getDotTop();
    // bind
    _about_history.bindScroll();
    _about_history.bindResize();
    _about_history.bindSlide();
  },
};

$(function(){
  _about_history.timeLine();

  // 給後端ajax呼叫綁定
  _common.timeLineLoad = function() {
    _about_history.getDotTop();
    _about_history.lineEvent($(window).scrollTop());
    _about_history.bindScroll();
    _about_history.bindSlide();
    _about_history.bindResize();
  };
});